import React,{ useEffect, useRef } from 'react';

const TolstoyStories = ({ currentProduct }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Clear previous instance
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    // Create a new <tolstoy-stories> element
    const scriptElement = document.createElement('tolstoy-stories');
    scriptElement.setAttribute('id', '79awcscgvnsez');
    scriptElement.setAttribute('class', 'tolstoy-stories');
    scriptElement.setAttribute('data-product-id', currentProduct.id);

    // Append it to the container
    containerRef.current.appendChild(scriptElement);

    // If Tolstoy requires a re-init function, you can call it here
    // e.g., window.Tolstoy?.init();

  }, [currentProduct.id]);

  return <div ref={containerRef}></div>;
};

export default TolstoyStories;
